import * as React from 'react';
import { IdHelper, IDropdownOptionDictionary } from '../../helpers';
import { Dropdown, IDropdownProps } from 'office-ui-fabric-react';

interface IProps extends IDropdownProps {
	tabIndex: number;
	required?: boolean;
	onChangedOnLoad?: boolean;

}

export class DropdownTabbed extends React.Component<IProps, any> {

	private dropdownId: string;

	private setTabIndex() {
		let wrapper = document.getElementById(this.dropdownId);
		if (wrapper) {
			let dropdown = wrapper.querySelector('.ms-Dropdown');
			if (dropdown) {
				dropdown.setAttribute('tabindex', this.props.tabIndex.toString());
			}
		}
	}

	public componentDidMount() {
		let { onChangedOnLoad, onChanged } = this.props;
		this.setTabIndex();

		if (onChangedOnLoad) {
			{ onChanged };
		}
	}

	public componentDidUpdate() {
		this.setTabIndex();
	}

	public render() {

		let { options, label, selectedKey, onChanged, className, required, disabled } = this.props;

		this.dropdownId = this.dropdownId || IdHelper.newGuid();

		// If the field is not required, ensure there is an "empty" option to cancel the selection
		let emptyOption = options.filter(x => x.key === "");
		if (!emptyOption.length && !required) {
			options.unshift({ index: 0, key: "", text: "-" });
		}

		// check if the action type is deprecated
		const optionsKeys = options.map(x => x.key);
		const isSelectedKeyDeprecated: boolean = selectedKey ? optionsKeys.indexOf(selectedKey.toString()) < 0 : false;
		label = isSelectedKeyDeprecated ? label + ' (' + selectedKey.toString() + ' is deprecated)' : label;

		return (
			<div id={this.dropdownId} className={(required ? 'required-field ' : null) + (required && !label && !selectedKey ? 'no-selected-key' : '')}>
				<Dropdown
					options={options}
					label={label}
					className={(className || '')}
					selectedKey={selectedKey}
					onChanged={onChanged}
					disabled={disabled}
				/>
			</div>
		);

	}

}



// WEBPACK FOOTER //
// ./source/ts/components/common/dropdown-tabbed.tsx